import { Box, TextField, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material'
import React, { useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import ShowComponents from '../../DoctorNotes/Common/ShowComponent'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import { COMMON_STYLE } from '../../../../Utility/Constants'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const notesState = {
  patientId: '',
  appointmentId: '',
  clinicId: '',
  doctorId: '',
  notesComments: '',
  dupNotesComments: '',
}

const UmaNotes = React.forwardRef((props, ref) => {
  const [notes, setNotes] = useState(notesState)
  const [message, setMessage] = useState({
    isErrorMsgText: '',
    successMsgText: '',
    isErrorMsg: false,
    successMsg: false,
  })

  const errorMessage = (message) => {
    setMessage({
      ...message,
      isErrorMsg: true,
      isErrorMsgText: `${message} - NOTES`,
    })
  }

  const successMessage = (message) => {
    setMessage({
      ...message,
      successMsg: true,
      successMsgText: `${message} - NOTES`,
    })
  }

  const msgClose = () => {
    setMessage({
      ...message,
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  React.useImperativeHandle(ref, () => ({
    performNotesAction: () => {
      if (JSON.stringify(notes.notesComments) !== notes.dupNotesComments) {
        postNotesData()
      }
    }
  }))

  const apicalls = async () => {
    await getNotesData()
  }

  const getNotesData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_NOTES + '?appointment_id=' + props?.props?.appointment_id + '&doctor_id=' + props?.props?.doctorID)
      if (response?.data?.status === 'success') {
        let notesData = Object.keys(response?.data?.data)?.length > 0 ? response?.data?.data : {}
        setNotes((prev) => ({
          ...prev,
          notesComments: Object.keys(notesData)?.length > 0 ? notesData?.comments : '',
          dupNotesComments: Object.keys(notesData)?.length > 0 ? JSON.stringify(notesData?.comments) : JSON.stringify(''),
        }))
        props.setAccordionOpen(notesData?.comments ? true : false);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const postNotesData = async () => {
    try {
      let data = {
        appointment_id: props?.props?.appointment_id,
        comments: notes.notesComments
      }
      const response = await RestAPIService.create(data, Serviceurls.NEW_DOC_NOTES_NOTES)
      if (response?.data?.status === 'success') {
        successMessage(response?.data?.message)
        await getNotesData()
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  return (
    <ShowComponents onIntersection={apicalls}>
      <Box component={'div'}>
        <Accordion expanded={props.accordionOpen}
          onChange={(_, isExpanded) => {
            props.setAccordionOpen(isExpanded, true);
          }}>
          <AccordionSummary className='doc_notes_header_card' expandIcon={<ExpandMoreIcon />}>
            <Typography className='doc_notes_header_card_font'>Notes</Typography>
          </AccordionSummary>
          <AccordionDetails component={'div'} m={'0.5rem'}>
            <TextField
              disabled={props?.props?.patient_transfered || props?.props?.isLocked}
              size='small'
              multiline
              fullWidth
              rows={8}
              maxRows={8}
              value={notes.notesComments}
              onChange={(e) => {
                let value = e.target.value
                if(value?.length <= COMMON_STYLE.CHAR_LIMIT_DESP || value === ''){
                  setNotes((prev) => ({ ...prev, notesComments: value }))
                }
              }}
              placeholder='Comments'
              InputProps={{ emed_tid: 'notes' }}
            />
          </AccordionDetails>
        </Accordion>
        {message.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={message.isErrorMsgText}
            msgPop={msgClose}
          />
          : null}
        {message.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={message.successMsgText}
            msgPop={msgClose}
          />
          : null}
      </Box>
    </ShowComponents>
  )
})

export default UmaNotes